<template>
  <authorization permissionKey="island_attendances_queue" can="read">
    <attendances
      v-if="attendancePlace"
      queueType="doctor"
      :attendancePlaceId="attendancePlace.id"
      :pollInterval=60000
    >
      <template v-slot:attendances="{ attendances, refreshQueue }">
        <v-row
          no-gutters
          v-for="(filteredAttendances, employeeName) in splitAttendances(attendances)"
          :key="employeeName"
        >
          <v-col cols="12" pa-0>
            <v-divider />

            <v-row no-gutters class="primary-light1">
              <v-col cols="12" class="px-3 py-0 mt-4 mb-2 font-weight-bold">
                <h3>
                  {{ employeeName }}
                </h3>
              </v-col>
            </v-row>

            <v-row no-gutters v-for="attendance in filteredAttendances" :key="attendance.id">
              <v-col cols="12" pa-0>
                <v-divider />

                <attendance :attendance="attendance" :refreshQueue="refreshQueue" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </attendances>
  </authorization>
</template>

<script>
  import attendances from "@/components/queues/attendances.vue";
  import attendance from "@/components/queues/attendance.vue";

  export default {
    name: "Attendances",
    components: {
      attendances,
      attendance,
    },
    props: {
      attendancePlace: Object,
    },
    methods: {
      splitAttendances(attendances) {
        const unordered = this.lodash.groupBy(attendances, "employee.name");
        const ordered = {};
        Object.keys(unordered)
          .sort()
          .forEach(function(key) {
            ordered[key] = unordered[key];
          });
        return ordered;
        // return this.lodash.groupBy(attendances, 'employee.name');
      },
    },
  };
</script>

<style lang="scss" scoped></style>
